import addDaysFNS from 'date-fns/addDays';
import endOfDayFNS from 'date-fns/endOfDay';
import startOfDayFNS from 'date-fns/startOfDay';

export enum AMPMFormat {
  AM = 'AM',
  PM = 'PM',
}

export const getMidday = (date = new Date()) => {
  const hours = date.getHours();
  return hours >= 12 ? AMPMFormat.PM : AMPMFormat.AM;
};
export const startOfDay = (date = new Date(), delta = 0) => {
  return startOfDayFNS(addDaysFNS(date, delta)).getTime();
};

// TODO partSize is always 24. https://app.launchdarkly.com/default/production/features/EPG_HOURS_DOWNLOAD/targeting
export const startPartOfDay = (date = new Date(), partSize = 24, delta = 0) => {
  return startOfDayFNS(addDaysFNS(date, delta)).getTime();
};

// TODO partSize is always 24. https://app.launchdarkly.com/default/production/features/EPG_HOURS_DOWNLOAD/targeting
export const endPartOfDay = (date = new Date(), partSize = 24, delta = 0) => {
  return endOfDayFNS(addDaysFNS(date, delta)).setSeconds(0, 0);
};

export const endOfDay = (date = new Date(), delta = 0) => {
  return endOfDayFNS(addDaysFNS(date, delta)).setSeconds(0, 0);
};

export const startOfMonth = (delta = 0, date = new Date()) => {
  return +new Date(date.getFullYear(), date.getMonth() + delta, 1, 0, 0, 0, 0);
};

export const dateToUTC = (date: number) => {
  const offset = new Date(Date.now()).getTimezoneOffset();
  if (date < 10000000000) {
    return date + offset * 60;
  }

  return date + offset * 60000;
};

/**
 *
 * @param delta: number
 * @param date: Date
 */

export const startOfWeek = (delta = 0, date = new Date()) => {
  const day = date.getDay();
  const diff = date.getDate() - day + (day === 0 ? -6 : 1);
  return +new Date(date.getFullYear(), date.getMonth() + delta, diff, 0, 0, 0, 0);
};

/**
 *
 * @param timeString - xx:xx
 */
export const timeStringToDate = (timeString: string) => {
  const [hours, minutes] = timeString.split(':').map(Number);
  const now = new Date();
  now.setHours(hours, minutes, 0, 0);
  return now;
};

export const upgradeWindowDates = (startTimeString: string, endTimeString: string, nowDate = new Date()) => {
  const startDate = timeStringToDate(startTimeString);
  const endDate = timeStringToDate(endTimeString);
  if (startDate > endDate) {
    endDate.setDate(endDate.getDate() + 1);
  }
  if (startDate > nowDate) {
    startDate.setDate(endDate.getDate() + 1);
    endDate.setDate(endDate.getDate() + 1);
  }
  return [startDate, endDate];
};

export enum DateFormatStyle {
  EpgDate,
}

/**
 * @deprecated
 * Utils class for formating dates.
 * @category Utils
 */
export class DateUtils {
  static formatDate(date: number, style?: DateFormatStyle, local = 'en'): string {
    const dateSource = date < 10000000000 ? date * 1000 : date;
    const dateObject = new Date(dateSource);

    switch (style) {
      case DateFormatStyle.EpgDate:
        return (
          Intl.DateTimeFormat(local, { weekday: 'short' }).format(dateObject) +
          ' ' +
          Intl.DateTimeFormat(local, { day: 'numeric' }).format(dateObject) +
          '.' +
          Intl.DateTimeFormat(local, { month: 'numeric' }).format(dateObject)
        );
      default:
        // eslint-disable-next-line no-case-declarations
        const d = new Date(dateSource);
        // TODO: add locale support
        return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear().toString().slice(-2)}`;
    }
  }
}

/**
 * @deprecated use shared program
 * @param startDate
 * @param local
 * @param primeTime
 */
export function getCatchUpAirDate(startDate: number, local: string, primeTime?: number) {
  const dateSource = startDate < 10000000000 ? startDate * 1000 : startDate;
  const currentHour = new Date(dateSource).getHours();
  const date = new Date(Date.now());
  const tomorrow = date.setDate(date.getDate() + 1);
  const startOfTommorow = new Date(tomorrow).setHours(0, 0, 0, 0);
  const endOfTommorrow = new Date(tomorrow).setHours(23, 59, 59, 999);
  const hour = Intl.DateTimeFormat('en', { hour: 'numeric', minute: 'numeric' }).format(dateSource);

  switch (true) {
    case dateSource < Date.now():
      return {
        values: [
          Intl.DateTimeFormat(local, { weekday: 'short' }).format(dateSource) +
            '. ' +
            Intl.DateTimeFormat('en', { day: 'numeric' }).format(dateSource) +
            '/' +
            Intl.DateTimeFormat('en', { month: 'numeric' }).format(dateSource),

          Intl.DateTimeFormat('en', { hour: 'numeric', minute: 'numeric', hour12: false }).format(dateSource),
        ],
      };
    case dateSource < startOfTommorow && primeTime && currentHour >= primeTime:
      return { id: 'tonight', value: hour };
    case dateSource < startOfTommorow:
      return { id: 'today', value: hour };
    case dateSource < endOfTommorrow:
      return { id: 'tomorrow', value: hour };
    default:
      return {
        values: [
          Intl.DateTimeFormat(local, { weekday: 'long' }).format(dateSource),

          Intl.DateTimeFormat('en', { day: 'numeric' }).format(dateSource) +
            '/' +
            Intl.DateTimeFormat('en', { month: 'numeric' }).format(dateSource),
        ],
      };
  }
}

export function isDateNumber(time: number) {
  return time > 1000000000;
}
